import http from "./http-common";
import authHeader from "./auth-header";

class SellerReviewService {
    addReview(data) {
        return http.post("seller-reviews-api", data, { headers: authHeader() });
    }

    getSellerReviews(sellerId) {
        return http.get(`seller-reviews-api/seller/${sellerId}`);
    }

    getSellerAverageRating(sellerId) {
        return http.get(`seller-reviews-api/seller/${sellerId}/average`);
    }
}

export default new SellerReviewService();
